// extracted by mini-css-extract-plugin
module.exports = {"title":"ModalMessage_title__Fgk_5","content":"ModalMessage_content__1_g-n"};